import React from 'react'

import { mountRouteUrl, openLink, ROUTES } from '@routes'

import { IBookingsResultsProps, OmniSearchBooking } from '../../OmniSearch.types'
import { BookingDetail } from './BookingDetail'
import ResultsTemplate from './ResultsTemplate'

function BookingsResults({
  activeIndex,
  bookings,
  enabledNavigation,
  homes,
  setIndex,
  searchTerm,
  totalCount,
  linkTarget,
  onClick,
}: IBookingsResultsProps): JSX.Element {
  const handleOnClick = (it: OmniSearchBooking) => {
    onClick
      ? onClick(it)
      : openLink(mountRouteUrl(ROUTES.bookingInfo.path, { hash: it.hash }), linkTarget)
  }

  return (
    <ResultsTemplate
      activeIndex={activeIndex - (homes?.length ?? 0)}
      data={bookings}
      enabledNavigation={enabledNavigation}
      baseUrl={ROUTES.bookings.path}
      queryParamKey="term"
      searchTerm={searchTerm}
      totalCount={totalCount}
      onClick={handleOnClick}
      setIndex={setIndex}
      titlePrefix={bookings.length === 1 ? 'booking' : 'bookings'}
      renderChildren={(booking: OmniSearchBooking) => <BookingDetail booking={booking} />}
    />
  )
}

export default BookingsResults
